/**
 * A pagina de uma lista (spec 058): mora na URL (`?pagina=2`), entao voltar e atualizar mantem e o link pode ser mandado.
 * Trocar busca, filtro ou aba volta pra 1 (`reiniciarCom`). Tela com mais de uma lista usa uma chave por lista.
 */
import { useCallback, useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router";

export function usePagina(chave = "pagina", reiniciarCom: unknown[] = []) {
  const [params, setParams] = useSearchParams();
  const pagina = Math.max(1, Number.parseInt(params.get(chave) ?? "", 10) || 1);
  // Ja esta na pagina pedida: nao navega. Navegar a toa a cada tecla da busca brigava com o clique num link logo depois
  // (a navegacao pra mesma tela cancelava a ida pra outra; visto no e2e, 20/10).
  const aoMudar = useCallback(
    (p: number) => {
      if (Math.max(1, p) === pagina) return;
      setParams((atual) => {
        const n = new URLSearchParams(atual);
        if (p <= 1) n.delete(chave);
        else n.set(chave, String(p));
        return n;
      }, { replace: true });
    },
    [chave, pagina, setParams],
  );
  // Na primeira vez nao reinicia: quem abriu o link com ?pagina=3 fica na 3.
  const assinatura = JSON.stringify(reiniciarCom);
  const primeira = useRef(true);
  useEffect(() => {
    if (primeira.current) { primeira.current = false; return; }
    aoMudar(1);
  }, [assinatura]); // eslint-disable-line react-hooks/exhaustive-deps
  return { pagina, aoMudar };
}

/** Pra lista que se repete na mesma tela (as aulas de cada modulo, as parcelas de cada ciclo): pagina so na tela. */
export function usePaginaLocal() {
  const [pagina, aoMudar] = useState(1);
  return { pagina, aoMudar };
}
